module.exports = __webpack_public_path__ + "static/media/FigmaLoginPage.017d7c0b.png";